import React from 'react';

const TaskContext = React.createContext({});

export default TaskContext;
